// extracted by mini-css-extract-plugin
export var button = "_40-0";
export var icon = "_40-1";